import { Search } from 'lucide-react'
import { useState } from 'react'
import { TrainingCard } from '@/components/training/TrainingCard'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Skeleton } from '@/components/ui/skeleton'
import { useTrainings } from '@/hooks/use-trainings'
import { buildTrainingFilters } from '@/lib/training-list'

export default function TrainingListPage() {
  const [search, setSearch] = useState('')
  const [trainingType, setTrainingType] = useState<string>('')
  const [category, setCategory] = useState('')

  const { data, isLoading } = useTrainings(buildTrainingFilters({ search, trainingType, category }))
  const trainings = Array.isArray(data) ? data : ((data as any)?.data ?? [])

  if (isLoading) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">研修一覧</h1>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Skeleton key={i} className="h-64" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">研修一覧</h1>

      <div className="flex flex-wrap gap-3">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="研修名で検索"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-9"
          />
        </div>
        <Select value={trainingType} onValueChange={setTrainingType}>
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="タイプ" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">すべて</SelectItem>
            <SelectItem value="open">募集型</SelectItem>
            <SelectItem value="assigned">アサイン型</SelectItem>
          </SelectContent>
        </Select>
        <Input
          placeholder="カテゴリ"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="w-[160px]"
        />
      </div>

      {trainings.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-muted-foreground">該当する研修がありません</p>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {trainings.map((t: any) => (
            <TrainingCard
              key={t.id}
              id={t.id}
              title={t.title}
              description={t.description}
              trainingType={t.trainingType}
              category={t.category}
              tags={t.tags}
              capacity={t.capacity}
              remainingSeats={t.remainingSeats}
              standardDurationHours={t.standardDurationHours}
            />
          ))}
        </div>
      )}
    </div>
  )
}
